export const BOLD_KEY = 'uui-richTextEditor-bold';
export const ITALIC_KEY = 'uui-richTextEditor-italic';
export const UNDERLINE_KEY = 'uui-richTextEditor-underlined';
